import React from 'react';

interface Tab {
  name: string;
  submitted?: boolean;
}

interface TabNavProps {
  active: string;
  tabs: (string | Tab)[];
  onSelect: (tab: string) => void;
}

const TabNav: React.FC<TabNavProps> = ({ active, tabs, onSelect }) => {
  return (
    <div className="bg-gray-100 p-2 rounded-xl mb-6 inline-block">
      <div className="flex flex-wrap gap-1">
        {tabs.map((tab) => {
          const tabName = typeof tab === 'string' ? tab : tab.name;
          const submitted = typeof tab === 'string' ? undefined : tab.submitted;
          return (
            <button
              key={tabName}
              onClick={() => onSelect(tabName)}
              className={`relative px-4 py-2 rounded-lg font-medium transition-all duration-200 flex items-center space-x-2 ${
                active === tabName
                  ? 'bg-white text-gray-900 shadow-sm border border-gray-200'
                  : 'text-gray-600 hover:text-gray-800 hover:bg-gray-200'
              }`}
            >
              <span>{tabName}</span>
              {submitted !== undefined && (
                <svg
                  className={`w-4 h-4 ${submitted ? 'text-green-600' : 'text-red-500'}`}
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  {submitted ? (
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  ) : (
                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                  )}
                </svg>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TabNav;

